import { gql } from "graphql-request";

export const ADMIN_VIEWER_USER_WORKSPACES = gql`
  query AdminViewerUserWorkspaces($emailOrId: String!) {
    adminViewerUserWorkspaces(emailOrId: $emailOrId) {
      user {
        id
        email
        name
      }
      workspaces {
        id
        name
        fileCount
        updatedAt
      }
    }
  }
`;

export const ADMIN_VIEWER_WORKSPACE_TREE = gql`
  query AdminViewerWorkspaceTree($workspaceId: ID!) {
    adminViewerWorkspaceTree(workspaceId: $workspaceId) {
      id
      type
      name
      parentId
      fileId
      order
    }
  }
`;

export const ADMIN_VIEWER_FILE_CONTENT = gql`
  query AdminViewerFileContent($fileId: ID!) {
    adminViewerFileContent(fileId: $fileId) {
      id
      title
      content
      charCount
      createdAt
      updatedAt
    }
  }
`;
